import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Shows the subtask import review modal from inside the task panel. The task
// record renders in #updated-offcanvas, whose active transform makes it the
// containing block for position:fixed descendants — a modal left in place gets
// trapped (and clipped) inside the panel. On connect the modal node is moved
// to document.body and shown; this controller's element is a placeholder that
// stays inside the turbo frame, so when the frame is replaced (import success,
// or reopening the upload form) disconnect() tears the moved modal down.
// Dismissal (X / Cancel) uses native data-bs-dismiss, since Stimulus actions
// inside the moved node can't reach a controller scoped to the placeholder.
export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.modalElement = this.modalTarget
    document.body.appendChild(this.modalElement)
    this.modal = new bootstrap.Modal(this.modalElement)
    this.modal.show()
    this.modalElement.addEventListener('turbo:submit-end', (event) => {
      if (event.detail.success) this.modal.hide()
    })
  }

  disconnect() {
    const teardown = () => {
      this.modal.dispose()
      this.modalElement.remove()
    }

    if (this.modalElement.classList.contains('show') || document.body.classList.contains('modal-open')) {
      this.modalElement.addEventListener('hidden.bs.modal', teardown, { once: true })
      this.modal.hide()
    } else {
      teardown()
    }
  }
}
